export default __webpack_public_path__ + "images/9567d5626f30342cf0119020e13b3bdc-mysticism_small.webp";